import { createActions } from "redux-actions";

const {
    uploadAvatar
} = createActions(
    'UPLOAD_AVATAR'
);

export { uploadAvatar }
